module.exports = __webpack_public_path__ + "media/images/lp_counseling_pc-1bb936574207b21a0281b3431fed25d3.png";